import { gql } from "@apollo/client";

export const GET_BLOQUEO_CLIENTE_SAP = gql`
  query bloqueoClienteSAP($codCliente: String!) {
  bloqueoClienteSAP(codCliente: $codCliente)
  }
`;